const BASE64_CHUNK_SIZE = 8192;

/** Encodes an ImageBitmap to a base64 JPEG string (no data: prefix). */
export async function bitmapToBase64Jpeg(bitmap: ImageBitmap, quality = 0.92): Promise<string> {
    const canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
    canvas.getContext('2d')!.drawImage(bitmap, 0, 0);
    const blob = await canvas.convertToBlob({ type: 'image/jpeg', quality });
    const bytes = new Uint8Array(await blob.arrayBuffer());

    // Build binary string in chunks to avoid O(n^2) string concatenation
    const parts: string[] = [];
    for (let i = 0; i < bytes.length; i += BASE64_CHUNK_SIZE) {
        parts.push(String.fromCharCode(...bytes.subarray(i, i + BASE64_CHUNK_SIZE)));
    }
    return btoa(parts.join(''));
}
